import { ActionHandler } from "../../../common/actions/core/action-handler";
import { Action } from "../../../common/actions/core/action";
import { OpenStudentNoSubAction } from "./nosub.action";
import { UserResponse } from "../../../common/services/user/user.model";
import GlobalSpinnerService from "../../../common/services/spinner/global-spinner.service";
import UserService from "../../../common/services/user/user.service";
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";

/*@ngInject*/
export default class OpenStudentNoSubController implements ActionHandler{
  protected user: UserResponse;
  protected dialogElement;
  protected content;

  constructor(
    protected $element,
    protected $sce,
    protected $window,
    protected i18n,
    protected config,
    protected actionDispatcher: ActionDispatcherService,
    protected globalSpinner: GlobalSpinnerService,
    protected userService: UserService
  ) {}

  public $postLink() {
    this.dialogElement = this.$element.find('#student-plan-application-modal').remodal();
    this.actionDispatcher.register(this);
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }
  public handle(action: Action) {
    if (action instanceof OpenStudentNoSubAction) {
      this.handleDialogAction(action);
    }
  }

  protected handleDialogAction(action: OpenStudentNoSubAction) {

    this.globalSpinner.start();
    this.userService.getUserInfo()
      .then(data => {
        this.user = data;
        this.content = this.$sce.trustAsHtml(
          '<iframe height="750" width="400" scrolling="no" style="overflow: hidden; margin-top: -10px;" src="' + this.config.sheerId.formUrl + '?locale=' + (this.i18n.getCurrentLanguage() == 'en' ? 'en' : 'tr') + '&userId=' + encodeURIComponent(this.user.encryptedId) + '"></iframe>'
        );
        this.openDialog();
      })
      .finally(() => {
        this.globalSpinner.stop();
      });
  }

  public onCancel() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  private close() {
    this.dialogElement.close();
    this.$window.location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/student/nosub/nosub.controller.ts